import React, { useMemo } from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { useTable } from 'react-table';

const SurveyHistoryTable = ({ 
  columns = [], 
  data = [], 
  className = "",
  emptyMessage = "No hay datos disponibles" 
}) => {
  
  const tableColumns = useMemo(() => columns, [columns]);
  const tableData = useMemo(() => data, [data]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns: tableColumns,
    data: tableData,
  });

  if (!data || data.length === 0) {
    return (
      <div className={`text-center py-8 text-gray-500 ${className}`}>
        {emptyMessage}
      </div>
    );
  }

  return (
    <SimpleBar className={`max-w-full max-h-full table-simplebar scroll-container  ${className}`}>
      <table {...getTableProps()} className="w-full border bg-white border-[#B9B9B9]">
        <thead className="">
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  {...column.getHeaderProps()}
                  className="px-4 py-3 min-h-[42px] text-xs text-center text-white font-itcdemi bg-blue border-r border-[#B9B9B9] last:border-r-0"
                  style={{ 
                    minWidth: column.minWidth || 'auto',
                    width: column.width || 'auto'
                  }}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()} className="bg-white">
          {rows.map(row => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} className="border-b border-[#B9B9B9] last:border-b-0">
                {row.cells.map(cell => {
                  
                  return (
                    <td
                      {...cell.getCellProps()}
                      className="px-4 py-4 text-sm text-center font-itcbook border-r border-[#B9B9B9] last:border-r-0"
                      style={{ 
                        minWidth: cell.column.minWidth || 'auto',
                        width: cell.column.width || 'auto',
                        whiteSpace: 'normal',
                        wordWrap: 'break-word'
                      }}
                    >
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </SimpleBar>
  );
};

export default SurveyHistoryTable;